/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { normalizeCard } from 'app/gamma/src/api/normalizers/card';
// eslint-disable-next-line no-restricted-imports
import {
  LOAD_BOARD_SUCCESS,
  LoadBoardSuccessAction,
} from 'app/gamma/src/modules/loaders/load-board';
// eslint-disable-next-line no-restricted-imports
import {
  LOAD_CARD_SUCCESS,
  LoadCardSuccessAction,
} from 'app/gamma/src/modules/loaders/load-card';
// eslint-disable-next-line no-restricted-imports
import { SOCKET_CARD, SocketCardAction } from 'app/gamma/src/modules/sockets';
// eslint-disable-next-line no-restricted-imports
import { CardModel } from 'app/gamma/src/types/models';
// eslint-disable-next-line no-restricted-imports
import { createReducer } from '@trello/redux';
import { PERFORM_SEARCH_SUCCESS, PerformSearchSuccessAction } from './search';
import updateModelList from './util/updateModelList';
// eslint-disable-next-line no-restricted-imports
import {
  LOAD_NOTIFICATION_GROUPS_SUCCESS,
  LoadNotificationGroupsSuccessAction,
} from 'app/gamma/src/modules/loaders/load-notifications';
// eslint-disable-next-line no-restricted-imports
import { CardResponse } from 'app/gamma/src/types/responses';

// Reducer
export type CardState = CardModel[];
const initialState: CardState = [];

export default createReducer(initialState, {
  [LOAD_BOARD_SUCCESS](state: CardState, { payload }: LoadBoardSuccessAction) {
    return updateModelList(state, payload.cards || [], normalizeCard);
  },

  [LOAD_CARD_SUCCESS](state: CardState, { payload }: LoadCardSuccessAction) {
    return updateModelList(state, payload, normalizeCard);
  },

  [SOCKET_CARD](state: CardState, { payload }: SocketCardAction) {
    return updateModelList(state, payload, normalizeCard);
  },

  [PERFORM_SEARCH_SUCCESS](
    state: CardState,
    { payload }: PerformSearchSuccessAction,
  ) {
    return updateModelList(state, payload.cards || [], normalizeCard);
  },

  [LOAD_NOTIFICATION_GROUPS_SUCCESS](
    state: CardState,
    { payload }: LoadNotificationGroupsSuccessAction,
  ) {
    const { notificationGroupsResponse } = payload;

    const cards = notificationGroupsResponse
      .map((notification) => notification.card)
      .filter(
        (potentialCard): potentialCard is CardResponse =>
          potentialCard !== undefined && potentialCard !== null,
      );

    return updateModelList(state, cards, normalizeCard);
  },
});
